module.exports = ":host /deep/ .datepicker-input .custom-select {\n  width: 50%; }\n\n.jumbotron, container {\n  padding-top: 10px; }\n"